const NAMESPACE = 'PRODUCTS';
export const CLEAR_ITEMS = `${NAMESPACE}_CLEAR_ITEMS`;
export const FETCH_ITEMS = `${NAMESPACE}_FETCH_ITEMS`;
export const FETCH_ITEM = `${NAMESPACE}_FETCH_ITEM`;
export const UPDATE_ITEM = `${NAMESPACE}_UPDATE_ITEM`;
export const ADD_ITEM = `${NAMESPACE}_ADD_ITEM`;
export const DELETE_ITEM = `${NAMESPACE}_DELETE_ITEM`;
export const UPDATE_INVENTORY = `${NAMESPACE}_UPDATE_INVENTORY`;
export const BULK_UPDATE_INVENTORY = `${NAMESPACE}_BULK_UPDATE_INVENTORY`;

export const MATCHES_PENDING_STATUS = 'pending';
export const MATCHES_ARCHIVED_STATUS = 'archived';
export const MATCHES_CONNECTED_STATUS = 'connected';
export const ECOMMERCE_INTEGRATION_ACTION = 'ecommerceIntegration';

export const INVENTORY_ACTIONS = [
  {
    labelKey: 'reports:inventory_action.new_inventory',
    value: 'newInventory',
  },
  {
    labelKey: 'reports:inventory_action.ecommerce_integration',
    value: ECOMMERCE_INTEGRATION_ACTION,
  },
  {
    labelKey: 'reports:inventory_action.damaged',
    value: 'damaged',
  },
  {
    labelKey: 'reports:inventory_action.stock_taking',
    value: 'stockTaking',
  },
  {
    labelKey: 'reports:inventory_action.returned',
    value: 'returned',
  },
  {
    labelKey: 'reports:inventory_action.retail',
    value: 'retail',
  },
  {
    labelKey: 'reports:inventory_action.backbar',
    value: 'backbar',
  },
  {
    labelKey: 'reports:inventory_action.other',
    value: 'other',
  },
];
